module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tab_profile":"Profile","tab_point_records":"Member Point Records"},"zh":{"tab_profile":"個人資料","tab_point_records":"會員點數紀錄"}}')
  delete Component.options._Ctor
}
